export enum AbnSoleTraderQuestion {
  WhyApplyingForAbn = "WHY_APPLYING_FOR_ABN",
  CurrentlyHaveOrPreviouslyHadAbn = "CURRENTLY_HAVE_OR_PREVIOUSLY_HAD_ABN",
  FirstTimeRunningBusiness = "FIRST_TIME_RUNNING_BUSINESS",
  PreviousAbn = "PREVIOUS_ABN",
  FirstTimeSelfEmployed = "FIRST_TIME_SELF_EMPLOYED",
  BusinessDescription = "BUSINESS_DESCRIPTION",
  BusinessActivities = "BUSINESS_ACTIVITIES",
  BusinessAddress = "BUSINESS_ADDRESS",
  PostalAddress = "POSTAL_ADDRESS",
  AgriculturalOperations = "AGRICULTURAL_OPERATIONS",
}

export const ABN_SOLE_TRADER_FIELD_TO_PATH: Record<AbnSoleTraderQuestion, string> = {
  [AbnSoleTraderQuestion.WhyApplyingForAbn]: "why-applying",
  [AbnSoleTraderQuestion.CurrentlyHaveOrPreviouslyHadAbn]: "have-abn",
  [AbnSoleTraderQuestion.FirstTimeRunningBusiness]: "first-time-business",
  [AbnSoleTraderQuestion.PreviousAbn]: "previous-abn",
  [AbnSoleTraderQuestion.FirstTimeSelfEmployed]: "first-time-self-employed",
  [AbnSoleTraderQuestion.BusinessDescription]: "business-description",
  [AbnSoleTraderQuestion.BusinessActivities]: "business-activities",
  [AbnSoleTraderQuestion.BusinessAddress]: "business-address",
  [AbnSoleTraderQuestion.PostalAddress]: "postal-address",
  [AbnSoleTraderQuestion.AgriculturalOperations]: "agricultural-operations",
};

export interface AbnSoleTraderAnswerTrailEntry {
  answerId: string;
  questionId: string;
  nextQuestionId: string;
}

export enum YesNoAnswer {
  Yes = "YES",
  No = "NO",
}
